import { WishList, WishListAnalyticsObject } from "../interfaces/wish-list-items.interface";

export function mapWishListToWishListAnalyticsObject(wishList: WishList): WishListAnalyticsObject {
  return {
    wishListId: wishList.wishlist_id,
    customerId: wishList.customer_id,
    wishListName: wishList.name,
    comments: wishList.comments,
    imageUrl: wishList.image_url,
    updatedAt: wishList.updated_at,
    createdAt: wishList.created_at,
    wishListItems: wishList.wishlist_items?.map((item) => {
      return {
        wishListItemId: item.wishlist_item_id,
        wishListId: item.wishlist_id,
        productId: item.product_id,
        qty: item.qty,
        isbn10: item.isbn10,
        isbn13: item.isbn13,
        wishListItemName: item.name,
        edition: item.edition,
        authors: item.authors?.map((author) => {
          return {
            givenName: author.given_name,
            familyName: author.family_name,
          } 
        }),
        addedAt: item.added_at,
        comments: item.comments,
        copyright: item.copyright,
        minGrade: item.min_grade,
        maxGrade: item.max_grade,
        businessUnit: item.business_unit,
        netPrice: item.net_price,
        listPrice: item.list_price,
        imageUrl: item.image_url,
      }
    }),
  }
}